import { render, staticRenderFns } from "./ModalAddAnimals.vue?vue&type=template&id=17ba71cc&scoped=true&"
import script from "./ModalAddAnimals.vue?vue&type=script&lang=js&"
export * from "./ModalAddAnimals.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddAnimals.vue?vue&type=style&index=0&id=17ba71cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ba71cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VAutocomplete,VBtn,VCard,VCardText,VCardTitle,VDialog})
